/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { createGetPromptCatalogueService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/ServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/StudioTextConstants';

export default createGetPromptCatalogueService({
  eventName: constants.GET_PROMPT_CATALOGUE,
  statusKey: 'getPromptCatalogueStatus',
  storeName: 'studioPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_CATALOGUE,
  errorEvent: constants.GET_PROMPT_CATALOGUE_ERROR
});
